import React, { Component } from 'react'
import { default as data } from '../../_constants/fieldOfActivity'
import Checkbox from '../Shared/Checkbox'
import { Formik, Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../Shared/ErrorPopUp'

class FieldOfActivitySelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value })
    }
  }

  handleChange = (e) => {
    let value = this.state.value || [];

    let idx = value.indexOf(e);
    if (idx > -1) {
      value.splice(idx, 1)
    } else {
      value.push(e)
    }
    this.props.onChange(value)
  }

  render() {
    const { value } = this.state;
    const { setFieldValue, touched, errors, values } = this.props;

    return (
      <div className="row">
        {data.map((item, index) => (
          <div className="col-md-6 col-sm-12" key={index}>
            <div className="flex-row">
              <Checkbox
                title={item.label}
                className="material-ui-checkbox"
                onChange={() => {
                  this.handleChange(item.value)
                }
                }
                checked={value !== undefined && value.includes(item.value)}
              />
              {values.fieldOfActivity && values.fieldOfActivity.includes(1) && item.value === 1 ?
                <div style={{ width: '100%' }}>
                  <input type="text"
                    onChange={(e) => {
                      setFieldValue('fieldOfActivityOther', e.target.value);
                    }}
                    placeholder="سایر فعالیت های خود را اینجا بنویسید"
                    name="fieldOfActivityOther"
                    className={getIn(touched, "fieldOfActivityOther") ? getIn(errors, "fieldOfActivityOther") ? "text-input has-error rtl" : "text-input rtl" : "text-input has-error rtl"}
                    style={{ marginBottom: 0, marginRight: 10 }}
                  />
                  <ErrorMessage component={ErrorPopUp} name="fieldOfActivityOther" style={{ top: -22, left: 5 }} />
                </div>
                : ''}
            </div>
          </div>
        ))}
      </div>
    );
  }
}



export default FieldOfActivitySelect;
